function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.71 16.29a1 1 0 010 1.42 1 1 0 01-1.42 0L9 10.41l-7.29 7.3a1 1 0 01-1.42 0 1 1 0 010-1.42L7.59 9 .29 1.71A1 1 0 011.71.29L9 7.59l7.29-7.3a1 1 0 111.42 1.42L10.41 9z",
  fill: "#0080ff",
  "data-name": "Vrstva 1"
}));

function SvgMobileMenuOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOCAxOCI+PGRlZnM+PHN0eWxlPi5jbHMtMSB7ZmlsbDogIzAwODBmZjt9DQo8L3N0eWxlPjwvZGVmcz48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iVnJzdHZhXzEiIGRhdGEtbmFtZT0iVnJzdHZhIDEiPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTE3LjcxLDE2LjI5YTEsMSwwLDAsMSwwLDEuNDIsMSwxLDAsMCwxLTEuNDIsMEw5LDEwLjQxbC03LjI5LDcuM2ExLDEsMCwwLDEtMS40MiwwLDEsMSwwLDAsMSwwLTEuNDJMNy41OSw5LC4yOSwxLjcxQTEsMSwwLDAsMSwxLjcxLjI5TDksNy41OSwxNi4yOS4yOWExLDEsMCwxLDEsMS40MiwxLjQyTDEwLjQxLDlaIi8+PC9nPjwvZz48L3N2Zz4=";
export { SvgMobileMenuOff as ReactComponent };